"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonSelector = exports.FooterSelector = exports.RootSelector = void 0;
exports.RootSelector = "#page-modal-dialog";
exports.FooterSelector = ".modal-footer";
exports.ButtonSelector = "button, [role=\"radio\"]"; // for toggle switch
